import { Navigate } from 'react-router'

const redirectState = { isRedirect: true } as const

/**
 * Sends the person on in place of the page asked for, by a replace, so Back skips it. The page it
 * lands on stands in for the one asked for: on the first load, focus stays where the browser put it.
 */
export function Redirect(props: { readonly to: string }) {
  return <Navigate to={props.to} replace state={redirectState} />
}

/** Whether a location's state says a {@link Redirect} led to it. */
export function isRedirect(state: unknown): boolean {
  return typeof state === 'object' && state !== null && 'isRedirect' in state && state.isRedirect === true
}
